import { css } from '@emotion/css';
import { appColors, breakpoints, fontFamily } from '../styles/variables.style';

export const title = css`
  font-family: ${fontFamily.fredoka};
  color: ${appColors.gray200};
  margin: 0 0 20px;
  text-align: center;
  font-size: 30px;

  span {
    font-size: 36px;
    color: ${appColors.orange};
  }
`;

export const img = css`
  display: block;
  max-width: 100%;
  width: 180px;
  height: 180px;
  object-fit: contain;
  margin: 0 auto 30px;
`;



export const indicator = css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  div {
    width: 10px;
    height: 10px;
    background-color: ${appColors.gray200};
    margin: 0 2px;
    border-radius: 50%;

    &.active {
      background-color: ${appColors.orange};
    }
  }
`;

export const questions = css`
  font-size: 12px;
  text-align: center;
  color: ${appColors.gray800};
  font-family: ${fontFamily.fredoka};
  margin: 0 auto 30px;
  max-width: 1880px;

  @media (min-width: ${breakpoints.lg.up}) {
    font-size: 29px;
  }
`;

export const note = css`
  font-size: 4px;
  text-align: center;
  color: ${appColors.gray800};
  font-family: ${fontFamily.fredoka};
  margin: 0 auto 30px;
  max-width: 1880px;

  @media (min-width: ${breakpoints.lg.up}) {
    font-size: 15px;
  }
`;


export const meanings = css`
  font-size: 12px;
  text-align: center;
  color: ${appColors.gray800};
  font-family: ${fontFamily.fredoka};
  margin: 0 auto 30px;
  max-width: 880px;

  @media (min-width: ${breakpoints.lg.up}) {
    font-size: 22px;
  }
`;


export const input = css`
  display: block;
  margin: 0 auto;
  width: 100%;
  max-width: 525px;
  height: 53px;
  background: ${appColors.white};
  border-radius: 10px;
  border: 1px solid transparent;
  padding: 0 10px;

  @media (min-width: ${breakpoints.lg.up}) {
    padding: 0 36px;
    height: 63px;
  }
`;

export const answers = css`
  background: ${appColors.orange};
  padding: 10px;
  border-radius: 10px 10px 0 0;

  @media (min-width: ${breakpoints.lg.up}) {
    padding: 20px;
  }

  .s-title {
    text-align: center;
    font-size: 34px;
    color: ${appColors.white};
    font-family: ${fontFamily.fredoka};
    margin: 0 0 10px;

    @media (min-width: ${breakpoints.lg.up}) {
      font-size: 30px;
    }
  }
`;





export const iconGroup = css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  img {
    width: 40px;
    height: 40px;
    margin: 0 10px;
    display: block;
  }

  img:hover {
    cursor: pointer;
  }
`;

export const imgPoster = css`
  display: block;
  margin: 0 auto 20px;
  width: auto;
  max-width: 100%;
  height: 300px;
  object-fit: contain;
`;
